<template>                    
    
    <v-layout row>
        <v-flex xs5>
            <v-select                        
                label="Auswahl Types"
                autocomplete
                v-bind:async-loading="loading"
                dark
                multiple
                cache-items
                chips
                required
                v-bind:items="types"     
                item-text="name"
                item-value="id"
                return-object
                v-bind:search-input.sync="search"
                v-model="mk.types"></v-select>
        </v-flex>

        <v-flex xs6 offset-xs1> 
            <v-layout row wrap>
                <v-flex xs6 v-for="(type,index) in mk.types" v-bind:key="index">
                    <p><strong> {{ type.name }} </strong></p>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
       

</template>

<script>

export default {
    
    data() {
        return {           
                    
            search: null,            
        };
    },
    watch: {
      search (val) {
        val && this.querySelections(val)
      }
    },
    /*created: function(){
        this.$store.dispatch('setTypes')
    },*/
    computed: {
        types: function() {
            
            return this.$store.getters.types
        },
        mk: function() {
            return this.$store.getters.marke
        },
        loading: function() {
            return this.$store.getters.loading
        }
    },
    methods: {

        querySelections (v) {
            //this.loading = true               
            this.mk.types = this.types.filter(e => {
                    return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
            })
            //this.loading = false
        
        },
              
    }
}
    
</script>

<style>
    
    
    
</style>


// WEBPACK FOOTER //
// typesSelect.vue?4ef511de